import React from 'react';
import { Route, Routes } from 'react-router-dom';
import PrescriptionDetector from './PrescriptionDetector';
import PresDectLogin from './Auth/PresDectLogin';
import PresDectPrivateRoute from './Auth/PresDectPrivateRoute';
import Pagenotfound from '../components/views/PageNotFound';
import UploadPrescription from './Lovable_component/LovablePrescription';
import PrescriptionLanding from './Lovable_component/PrescriptionLanding';


export default function PrescriptionDectRoute() {
  return (
    <div>
      <Routes>
        <Route path="/prescription">
          <Route path="*" element={<Pagenotfound />} />
          <Route path="prescriptionUtility" element={<PrescriptionLanding />} />
          <Route path="login" element={<PresDectLogin />} />
          <Route
            path="detector"
            element={
              <PresDectPrivateRoute>
                <UploadPrescription />
              </PresDectPrivateRoute>
            }
          />
        </Route>
      </Routes>
    </div>
  );
}
